(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.cp-reveal:not(.cp-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cp-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cp-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var media = document.querySelectorAll('[data-cp-parallax]');
    if (!media.length || reduce) return;
    var ticking = false;
    function update() {
      media.forEach(function (m) {
        var k = parseFloat(m.getAttribute('data-cp-parallax')) || 0;
        var r = m.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        m.style.transform = 'translate3d(0,' + (-r.top * k) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initCifras() {
    var nums = document.querySelectorAll('[data-cp-count]');
    if (!nums.length) return;
    function run(el) {
      var fin = parseFloat(el.getAttribute('data-cp-count'));
      var dec = parseInt(el.getAttribute('data-cp-dec') || '0', 10);
      var pre = el.getAttribute('data-cp-pre') || '';
      var suf = el.getAttribute('data-cp-suf') || '';
      if (reduce) { el.textContent = pre + fin.toFixed(dec).replace('.', ',') + suf; return; }
      var t0 = null, dur = 1800;
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = pre + v.toFixed(dec).replace('.', ',') + suf;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function init() { initReveal(); initParallax(); initCifras(); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
